import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import * as sessionUserSelector from 'selectors/sessionUser'

import {
  useFetchSessionUserQuery,
  useUpdateSessionUserMutation,
  useUpdateUserAvatarMutation,
} from 'api/sessionUser'

import MainWrap from 'components/Shared/Skeleton/MainWrap/Index'
import Content from 'components/Shared/Skeleton/Content/Index'
import Header from 'components/Shared/Header/Index'

import ProfileAvatar from './ProfileAvatar'
import ProfileForm from './ProfileForm'

const StyledHeader = styled(Header)`
  max-width: 944px;

  .title-wrapper {
    justify-content: space-between;
  }
`

const ProfilePage = props => {
  const userDisplayName = useSelector(sessionUserSelector.displayName)
  const userAvatarUrl = useSelector(sessionUserSelector.avatarUrl)
  const { t } = useTranslation()

  const { isFetching } = useFetchSessionUserQuery() // ignore received data here, use selectors
  const [updateSessionUser, { isLoading: isUpdating }] = useUpdateSessionUserMutation()
  const [updateUserAvatar] = useUpdateUserAvatarMutation()

  // do not use updateSessionUser directly in <ProfilForm onSubmit={...}/>
  // as React Final Form decides that there is an error returned
  // and "Update" button becomes disabled ignoring any editing
  const onSubmit = (data) => {
    updateSessionUser(data)
  }

  const onUpdateAvatar = (userAvatarFile) => {
    updateUserAvatar({ avatar: userAvatarFile })
  }

  const breadcrumbsList = [{ text: t('common.breadcrumbUserProfile') }]

  return (
    <MainWrap pageTitle={userDisplayName}>
      <Content loading={isFetching || isUpdating}>
        <StyledHeader
          title={userDisplayName}
          breadcrumbsList={breadcrumbsList}
          titleRightZone={
            <ProfileAvatar
              userAvatarUrl={userAvatarUrl}
              updateAvatar={onUpdateAvatar}
            />
          }
        />
        <ProfileForm onSubmit={onSubmit} />
      </Content>
    </MainWrap>
  )
}

export default ProfilePage
